import { Navigate, useParams } from "react-router-dom";
import useProducts from "../hooks/useProducts";

import ProductGallery from "../components/product/ProductGallery";
import ProductInfo from "../components/product/ProductInfo";
import ProductDetailsInfo from "../components/product/ProductDetailsInfo";
import RelatedProducts from "../components/product/RelatedProducts";

const ProductDetails = () => {

  const { id } = useParams();

  const {
    products,
    loading
  } = useProducts();



  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading product...
      </div>
    );
  }



  const product = products.find(
    (item) => item._id === id
  );



  if (!product) {
    return <Navigate to="/shop" replace />;
  }

  return (
    <main className="bg-gray-50 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Breadcrumb */}
        <div className="mb-8 text-sm text-gray-500">
          Home / Shop / {product.category.title} /{" "}
          <span className="text-green-600 font-medium">{product.name}</span>
        </div>

        {/* Product Section */}
        <div
          className="
            bg-white
            rounded-3xl
            shadow-sm
            border
            border-gray-200
            p-6
            lg:p-10
          "
        >
          <div
            className="
              grid
              grid-cols-1
              lg:grid-cols-2
              gap-10
              items-start
            "
          >
            <ProductGallery product={product} />

            <ProductInfo product={product} />
          </div>
        </div>
        <ProductDetailsInfo product={product} />
        <RelatedProducts products={products} currentProduct={product} />
      </div>
    </main>
  );
};

export default ProductDetails;
